import { useNavigate } from "react-router-dom";

import { T } from "@repo/transifex";
import { useUserProductsPos } from "~/api/products/hooks/use-user-products";
import { useAppContext } from "~/providers/app";
import { usePrintOrderReceipt } from "~/hooks/queries/orders";

import { Button, type ButtonProps } from "../../Button";

type PrintButtonProps = ButtonProps & {
  orderId: string;
  receiptList?: string[];
};

export const PrintButton = ({
  orderId,
  receiptList,
  ...props
}: PrintButtonProps) => {
  const navigate = useNavigate();

  const { mutate: createReceipt } = usePrintOrderReceipt();
  const { data: userProducts } = useUserProductsPos();

  const {
    hardware: { printer }
  } = useAppContext();

  return (
    <Button
      disabled={!printer}
      hidden={printer === null}
      onClick={() => {
        createReceipt({
          orderId,
          userId: userProducts?.user?.id ?? null,
          receiptList
        });
        navigate({
          pathname: `/pos/sell/print`,
          search: `?orderId=${orderId}`
        });
      }}
      variant="secondary"
      {...props}
    >
      <T _str="Print receipt" />
    </Button>
  );
};
